import React from "react";
import IncomesList from "./components/IncomesList";
import { MwButton, CardHeadeWithActions } from "../../components/ui";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { TbReportMoney } from "react-icons/tb";
import { NewButton } from "../../components/ui/NewButton";
import { getDateNow } from "../../utils/global";

const HomeIncomes = () => {
  const [t] = useTranslation("global");
  const navgate = useNavigate();
  const params = useParams();
  const todayYmd = getDateNow().toLocaleDateString("en-CA");
  return (
    <div className="text-slatee-500 ">
      <CardHeadeWithActions>
        <div className="Salaries-top  w-[100%] mb-0 flex justify-between items-center">
          <div className="title flex justify-center gap-1 items-center">
            <img
              className="w-5 z-50"
              src="/assets/icons/Salries.png"
              alt="Branch"
            />{" "}
            <span className="text-[#261759] ms-1 font-bold ">{t("menu.Saleries")}</span>
          </div>
          <NewButton
            type="newBtn"
            onClick={() => navgate(`/${params.tenant}/incomes/add/${todayYmd}`)}
          >
            <span>{t("Salaries.addBond")}</span>{" "}
          </NewButton>
        </div>
      </CardHeadeWithActions>
      <IncomesList />
    </div>
  );
};

export default HomeIncomes;
